/* --------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

import service from '../../services/org';

const ORG_LOAD = 'ORG_LOAD';

const state = {
  org: null
};

const mutations = {
  [ORG_LOAD] (state, org) {
    state.org = org;
  }
};

const actions = {
  getOrg: ({ commit }) => {
    return service.get()
      .then(org => {
        commit(ORG_LOAD, org);
      });
  },
  resetOrg: ({ commit }) => {
    commit(ORG_LOAD, null);
  },
  setOrg: ({ commit }, org) => {
    commit(ORG_LOAD, org);
  },
};

const getters = {
  org: state => state.org
};

export default {
  state,
  mutations,
  actions,
  getters
};
